import script from "./vbreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./vbreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./vbreadcrumb.vue?vue&type=style&index=0&id=28f9cb8d&lang=css"

const __exports__ = script;

export default __exports__